import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFundraisingData } from './firebaseUtils';

function FargoCampaign() {
  const navigate = useNavigate();
  const [fundraising, setFundraising] = useState({ amountRaised: 0, goal: 2000, legacyGoal: 2500 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const data = await getFundraisingData();
      setFundraising(data);
      setLoading(false);
    };
    fetchData();
  }, []);

  const { amountRaised, goal, legacyGoal } = fundraising;
  const fargoProgress = Math.min((amountRaised / goal) * 100, 100);
  const legacyProgress = amountRaised > goal
    ? Math.min(((amountRaised - goal) / (legacyGoal - goal)) * 100, 100)
    : 0;
  const beyondLegacy = amountRaised > legacyGoal;

  const goldButtonStyle = {
    display: 'block',
    width: '100%',
    backgroundColor: '#FFD700',
    color: '#000',
    borderRadius: '10px',
    padding: '16px 24px',
    fontSize: '1.1rem',
    fontFamily: 'Bangers, sans-serif',
    letterSpacing: '2px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111',
      color: '#fff',
      paddingTop: '40px',
      paddingBottom: '60px',
    }}>
      <div style={{
        maxWidth: '700px',
        margin: '0 auto',
        padding: '0 16px',
      }}>

        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h1 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: 'clamp(2rem, 7vw, 3.5rem)',
            letterSpacing: '2px',
            color: '#FFD700',
            marginBottom: '8px',
          }}>
            🤼 Help Send Ben to Fargo!
          </h1>
          <p style={{ color: '#ccc', fontSize: '1.1rem' }}>
            Support Benjamin's journey to the national championship
          </p>
        </div>

        {/* DONATION BUTTONS */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '24px',
          textAlign: 'center',
          borderTop: '4px solid #FFD700',
        }}>

          {/* Founding Member */}
          <h2 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: '1.5rem',
            letterSpacing: '1px',
            color: '#FFD700',
            marginBottom: '8px',
          }}>
            🏆 Become a Founding Member
          </h2>
          <p style={{ color: '#ccc', marginBottom: '16px', fontSize: '0.95rem' }}>
            Unlock exclusive match footage for $4.99
          </p>
          <button
            onClick={() => window.open('https://paypal.me/BenjaminKinney365/4.99', '_blank')}
            style={{ ...goldButtonStyle, marginBottom: '8px' }}
          >
            🏆 Become a Founding Member — $4.99
          </button>
          <div style={{
            backgroundColor: '#222',
            borderRadius: '8px',
            padding: '12px 14px',
            marginBottom: '28px',
            textAlign: 'left',
          }}>
            <p style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '4px' }}>
              After paying:
            </p>
            <p style={{ color: '#ccc', fontSize: '0.85rem', margin: 0, lineHeight: '1.6' }}>
              DM <strong style={{ color: '#fff' }}>@BenjaminKinney365</strong> on Instagram with your PayPal confirmation and we'll send you the secret code to unlock exclusive content.
            </p>
          </div>

          {/* Divider */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '20px',
          }}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#333' }} />
            <h2 style={{
              fontFamily: 'Bangers, sans-serif',
              fontSize: '1.5rem',
              letterSpacing: '1px',
              color: '#FFD700',
              margin: 0,
              whiteSpace: 'nowrap',
            }}>
              💛 Donate Any Amount
            </h2>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#333' }} />
          </div>

          <p style={{ color: '#ccc', marginBottom: '16px', fontSize: '0.95rem' }}>
            Every dollar helps get Ben to Fargo
          </p>

          <div style={{ display: 'flex', gap: '12px', marginBottom: '8px' }}>
            <button
              onClick={() => window.open('https://paypal.me/BenjaminKinney365', '_blank')}
              style={{ ...goldButtonStyle, flex: 1 }}
            >
              💳 PayPal
            </button>
            <button
              onClick={() => window.open('https://venmo.com/u/Theodore-Kinney-1', '_blank')}
              style={{ ...goldButtonStyle, flex: 1 }}
            >
              💙 Venmo
            </button>
          </div>
          <p style={{ color: '#888', fontSize: '0.85rem', marginBottom: '20px' }}>
            Donate whatever feels right — no account required
          </p>

          <button
            onClick={() => navigate('/unlock')}
            style={{
              backgroundColor: 'transparent',
              color: '#888',
              border: '1px solid #444',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '0.95rem',
              cursor: 'pointer',
              width: '100%',
            }}
          >
            🔑 Already have a code? Unlock Premium Access
          </button>
        </div>

        {/* Thermometer */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '24px',
          textAlign: 'center',
        }}>
          <h2 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: '1.5rem',
            letterSpacing: '1px',
            color: '#FFD700',
            marginBottom: '20px',
          }}>
            📊 Fundraising Progress
          </h2>

          {loading ? (
            <p style={{ color: '#888' }}>Loading...</p>
          ) : (
            <div>
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}>
                  <span style={{ color: '#ccc', fontSize: '0.9rem' }}>🎯 Fargo Fund</span>
                  <span style={{ color: '#FFD700', fontWeight: 'bold' }}>
                    ${Math.min(amountRaised, goal).toLocaleString()} / ${goal.toLocaleString()}
                  </span>
                </div>
                <div style={{
                  backgroundColor: '#333',
                  borderRadius: '999px',
                  height: '28px',
                  overflow: 'hidden',
                }}>
                  <div style={{
                    width: `${fargoProgress}%`,
                    height: '100%',
                    backgroundColor: fargoProgress >= 100 ? '#FFD700' : '#ff4444',
                    borderRadius: '999px',
                    transition: 'width 1s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    color: '#000',
                  }}>
                    {fargoProgress > 10 ? `${Math.round(fargoProgress)}%` : ''}
                  </div>
                </div>
              </div>

              {amountRaised >= goal && (
                <div style={{ marginBottom: '20px' }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                  }}>
                    <span style={{ color: '#ccc', fontSize: '0.9rem' }}>🤼 Legacy Wrestling Club Giveback</span>
                    <span style={{ color: '#00ff88', fontWeight: 'bold' }}>
                      ${Math.min(amountRaised - goal, legacyGoal - goal).toLocaleString()} / ${(legacyGoal - goal).toLocaleString()}
                    </span>
                  </div>
                  <div style={{
                    backgroundColor: '#333',
                    borderRadius: '999px',
                    height: '28px',
                    overflow: 'hidden',
                  }}>
                    <div style={{
                      width: `${legacyProgress}%`,
                      height: '100%',
                      backgroundColor: '#00ff88',
                      borderRadius: '999px',
                      transition: 'width 1s ease',
                    }} />
                  </div>
                </div>
              )}

              {beyondLegacy && (
                <div style={{
                  backgroundColor: '#222',
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '16px',
                }}>
                  <p style={{ color: '#FFD700', fontWeight: 'bold', margin: 0 }}>
                    🚀 Fueling the Journey: ${(amountRaised - legacyGoal).toLocaleString()} raised beyond the Legacy goal!
                  </p>
                </div>
              )}

              <p style={{ color: '#888', fontSize: '0.9rem', marginTop: '8px' }}>
                Total raised: <strong style={{ color: '#fff' }}>${amountRaised.toLocaleString()}</strong>
              </p>
            </div>
          )}
        </div>

        {/* Story */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '24px',
          borderLeft: '4px solid #FFD700',
        }}>
          <h2 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: '1.5rem',
            letterSpacing: '1px',
            color: '#FFD700',
            marginBottom: '16px',
          }}>
            🏆 The Story
          </h2>
          <p style={{ color: '#ddd', lineHeight: '1.8', marginBottom: '14px' }}>
            <strong style={{ color: '#fff' }}>Benjamin Kinney (@BenjaminKinney365)</strong> has been selected to the Pennsylvania National Team to compete in the <strong style={{ color: '#fff' }}>2026 USA Wrestling Junior National Championships</strong> — held in Fargo, North Dakota, July 9-18, 2026.
          </p>
          <p style={{ color: '#ddd', lineHeight: '1.8', marginBottom: '14px' }}>
            This isn't just any tournament. According to Pennsylvania USA Wrestling State Chairman Joe Stabilito, this is <strong style={{ color: '#FFD700' }}>"the most important wrestling tournament of the year"</strong> for Benjamin's division — drawing the best high school wrestlers from every state in the country.
          </p>
          <p style={{ color: '#ddd', lineHeight: '1.8', marginBottom: '14px' }}>
            Earning a spot on the Pennsylvania National Team required placing at the PAUSAW State Tournament or a USA Wrestling Regional event. Ben qualified for Fargo by winning the Northeast Regionals in both Freestyle and Greco-Roman — something very few wrestlers accomplish.
          </p>
          <p style={{ color: '#ddd', lineHeight: '1.8', marginBottom: '14px' }}>
            The Pennsylvania USA Wrestling team fee alone is <strong style={{ color: '#fff' }}>$1,500</strong>. Add hotel, gas from Pittsburgh to North Dakota, and food for six days — and this is a significant investment in Benjamin's wrestling future.
          </p>
          <p style={{ color: '#ddd', lineHeight: '1.8', marginBottom: '14px' }}>
            We're not asking you to cover it all. We're asking you to help. Every dollar gets Benjamin closer to the mat in Fargo.
          </p>
          <p style={{
            color: '#FFD700',
            fontFamily: 'Bangers, sans-serif',
            fontSize: '1.2rem',
            letterSpacing: '1px',
          }}>
            We leave July 8th. Help us get there.
          </p>
        </div>

        {/* Cost Breakdown */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '24px',
        }}>
          <h2 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: '1.5rem',
            letterSpacing: '1px',
            color: '#FFD700',
            marginBottom: '16px',
          }}>
            💰 The Real Cost of Getting There
          </h2>
          {[
            { label: 'PA USAW Team Fee (gear, training camp, lodging)', amount: '$1,500' },
            { label: 'Hotel — Fargo, ND', amount: '$1,300' },
            { label: 'Gas — Pittsburgh to North Dakota', amount: '$625' },
            { label: 'Food and Expenses (6 days)', amount: '$400' },
          ].map((item, i) => (
            <div key={i} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              padding: '10px 0',
              borderBottom: '1px solid #333',
              gap: '12px',
            }}>
              <span style={{ color: '#ccc', fontSize: '0.95rem', textAlign: 'left' }}>{item.label}</span>
              <span style={{ color: '#FFD700', fontWeight: 'bold', whiteSpace: 'nowrap' }}>{item.amount}</span>
            </div>
          ))}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0 4px 0',
            marginTop: '4px',
          }}>
            <span style={{ color: '#aaa', fontSize: '0.95rem' }}>Total Trip Cost</span>
            <span style={{ color: '#aaa', fontWeight: 'bold' }}>~$3,825</span>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '10px 0 0 0',
            borderTop: '2px solid #FFD700',
            marginTop: '8px',
          }}>
            <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '1.1rem' }}>We're asking for</span>
            <span style={{ color: '#FFD700', fontWeight: 'bold', fontSize: '1.1rem' }}>$2,000</span>
          </div>
          <p style={{ color: '#888', fontSize: '0.85rem', marginTop: '8px', fontStyle: 'italic' }}>
            Just over half the trip cost — every dollar helps close the gap.
          </p>
        </div>

        {/* Legacy Giveback */}
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '24px',
          borderLeft: '4px solid #00ff88',
        }}>
          <h2 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: '1.5rem',
            letterSpacing: '1px',
            color: '#00ff88',
            marginBottom: '12px',
          }}>
            🤼 Paying It Forward
          </h2>
          <p style={{ color: '#ddd', lineHeight: '1.8' }}>
            Benjamin believes in giving back to the sport that shaped him. Every dollar raised <strong style={{ color: '#fff' }}>beyond the $2,000 Fargo goal up to $2,500</strong> will go directly toward buying shoes and gear for youth wrestlers at <strong style={{ color: '#fff' }}>Legacy Wrestling Club</strong> who need support to compete.
          </p>
          <p style={{ color: '#ddd', lineHeight: '1.8', marginTop: '12px' }}>
            Beyond $2,500, funds help fuel Benjamin's ongoing wrestling journey — training, travel, and future competitions.
          </p>
        </div>

        <p style={{
          textAlign: 'center',
          color: '#888',
          fontStyle: 'italic',
          fontSize: '1rem',
        }}>
          "Greatness comes from hard work. Stay on the GRIND!" — Benjamin Kinney
        </p>

      </div>
    </div>
  );
}

export default FargoCampaign;